import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { OptionItem } from '@classifieds-sell/datalayer';
import { Subject } from 'rxjs';
import { FormHelperService } from '../../../helpers/form-helper.service';
import { ListingDurationService } from '../../../services/listing-duration.service';
import { isEditOrRelistPage } from '../../../helpers/router.helper';
import { DraftFacade } from '@classifieds-sell/state';
import { FeeCalculationFacade } from '../../../state/fee-calculation/fee-calculation.facade';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-rental-availability-section',
    templateUrl: './property-rental-availability-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./property-rental-availability-section.component.scss']
})
export class PropertyRentalAvailabilitySectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('propertyRentalAvailabilitySectionForm')
    propertyRentalAvailabilitySectionForm: NgForm;

    minDate = new Date();
    durationDate: Date;
    public durationOptions: OptionItem[] = [];
    public isEditOrRelistPage = false;
    hasBeenAnExtension = false;

    sideCardIcon = '/sell/property/assets/property-ui/house.svg';
    sideCardHeading = 'Not sure how much rent to charge?';
    sideCardDescription =
        'Check our guide to setting a price that\'s both fair and competitive.';
    sideCardCallToActionText = 'Our guide for rental rate';
    sideCardCallToActionLink =
        'https://www.trademe.co.nz/c/property/article/how-much-rent-to-charge-for-your-property';

    constructor(
        public draftFacade: DraftFacade,
        private route: ActivatedRoute,
        private changeDetectorRef: ChangeDetectorRef,
        private formHelperService: FormHelperService,
        private listingDurationService: ListingDurationService,
        public feeCalculationFacade: FeeCalculationFacade
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.initData();
            this.updateAvailableText();
            this.hasBeenAnExtension = this.draftData.propertyInformation.duration === 0;
            this.changeDetectorRef.markForCheck();
        });
    }

    private initData(): void {
        this.durationOptions = this.listingDurationService.getDurationItems(this.metadata);
        this.isEditOrRelistPage = isEditOrRelistPage(this.route);

        if (this.isEditOrRelistPage) {
            this.minDate = new Date(1970, 1, 1);
        }
    }

    isValid(): boolean {
        this.formHelperService.validate(
            this.propertyRentalAvailabilitySectionForm
        );
        return this.propertyRentalAvailabilitySectionForm.form.valid;
    }

    dirty(): boolean {
        return this.propertyRentalAvailabilitySectionForm.form.dirty;
    }

    updateAvailableText() {
      const duration = this.draftData.propertyInformation.duration;
      this.durationDate = this.listingDurationService.availableDateText(this.metadata, duration);
    }

    updateAvailableDate(newDate: Date): void {
        this.draftData.propertyInformation.availableFrom = newDate;
        this.updateAvailableText();
        this.publish();
    }
}
